export const tr = {
	hello: 'Merhaba',
	download_cv: 'Download Cv',
	name: 'Adınız',
	message: 'Mesajınız...',
	country: 'Ülke',
	city: 'Şehir',
	age: 'Yaş',
	email : 'E-Posta',
	phone : 'Telefon',
	my_services : 'Neler Yapabilirim',
	price_plans : 'Fıyatlama',
	recommendations : 'Müşteri Yorumları',
	code_example : 'Kod Örnekleri',
	works : 'Son Yaptığım İşler',
	education : 'Eğitim Geçmişim',
	work_history : 'Çalışma Geçmişim',
	contact_information : 'İletişim Bilgilerim',
	contact_form : 'İletişim Formu',
	go_link : 'Ziyaret Et',
	technology : 'Kullandığım Teknolojiler',
	send_message : 'Mesaj Gönder',
};